import React, { Fragment, useState, useEffect } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { Checkmark } from "react-checkmark";
import axios from "axios";
import hotelimg from "../imagepreview.png";
import Lightbox from "react-image-lightbox";
const { config } = require("../api/api");

function HotelOrderStatus() {
  const base_url = config.baseURL;
  const [userData, setUserData] = useState(false);
  const [loading, setLoading] = useState(true);

  const { t } = useTranslation();
  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';

  const [orderData, setOrderData] = useState(false);
  const [OrderDetails, setOrderDetails] = useState("");

  // hotel img
  const [hotelimage, setHotelImage] = useState({});
  const [roomimage, setRoomImage] = useState([]);
  const [currentHotelId, setCurrentHotelId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [segmentsData,setSegmentsData]= useState(null);
  useEffect(() => {
    const storedOrderString = sessionStorage.getItem("orderResult");
    if (storedOrderString) {
      const storedOrder = JSON.parse(storedOrderString);
      setOrderData(storedOrder);
    }
  }, []);

  useEffect(() => {
    const storedUserString = Cookies.get("userData"); //sessionStorage.getItem('userData')
    if (storedUserString !== undefined) {
      const storedUser = JSON.parse(storedUserString);
      setUserData(storedUser);
    }
  }, []);

  const usrtok = userData.access_token;
  // console.log(usrtok)

  const urlSearchString = window.location.search;

  const uparams = new URLSearchParams(urlSearchString);

  const order_id = uparams.get("order_id");
  const [vendorKey, setVendorKey] = useState("");
  const [etmtoken, setEtmtoken] = useState("");
    const [amenities,setAmenities]=useState([]);
    const [facilitiesPopup,setFacilitiesPopup]=useState(false);

  useEffect(() => {
    const postvData = { organization_name: "Superjet" };

    if (vendorKey === "" || vendorKey === null || vendorKey === undefined) {
      fetch(base_url + "/create_organization", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postvData),
      })
        .then((response) => response.json())
        .then((data) => {
          setVendorKey(data.result[0].vendor_key);

          fetch(base_url + "/hotel_login", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${data.result[0].vendor_key}`,
            },
          })
            .then((response) => response.json())
            .then((data) => {
              setEtmtoken(data.result.etm_auth_key);
              const token = data.result.etm_auth_key;
              const expiredtoken = new Date();
              expiredtoken.setTime(expiredtoken.getTime() + 1 * 60 * 60 * 1000);
              Cookies.set("auth_key", JSON.stringify(token), {
                expires: expiredtoken,
              });
            })
            .catch((error) => {
              console.error("Error posting data:", error);
            });
        })
        .catch((error) => {
          console.error("Error posting data:", error);
        });
    }
  }, [vendorKey]);

  useEffect(() => {
    debugger;
    if (
      vendorKey !== "" &&
      vendorKey !== null &&
      vendorKey !== undefined &&
      order_id !== "" &&
      order_id !== null &&
      order_id !== undefined&&
etmtoken
    ) {
      var GivenData = {
        etmtoken: etmtoken,
        order_id: order_id,
      };

      fetch(base_url + "/check_hotel_order_status", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${vendorKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(GivenData),
      })
        .then((response) => response.json())
        .then((data) => {
          setOrderDetails(data.result);
          if (data.result.rooms && data.result.rooms.length > 0) {
            setRoomImage(data.result.rooms[0]?.images);
          }
          setLoading(false);
        })

        .catch((error) => {
          console.error("Error posting data:", error);
        });

         fetch(base_url + "/check_hotel_order_segments", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${vendorKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(GivenData),
      })
        .then((response) => response.json())
        .then((data) => {
           setSegmentsData(data.result.data[0]);
        })

        .catch((error) => {
          console.error("Error posting data:", error);
        });
    }
  }, [vendorKey, order_id, etmtoken]);

  const StarRating = ({ rating, totalStars = 5 }) => {
    if (rating) {
      const filledStars = Math.round(rating);
      const emptyStars = totalStars - filledStars;
      const filledArr = new Array(filledStars);
      filledArr.fill("fullStar");
      const emptyArr = new Array(emptyStars);
      emptyArr.fill("fullStar");
      return (
        <div className="star-rating" style={{ display: "flex", padding: "0" }}>
          {filledArr.map((_, index) => (
            <span
              key={`filled-${index}`}
              //   onClick={() => handleStarClick(index)}
              style={{ color: "gold", cursor: "pointer" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-star-fill"
                viewBox="0 0 16 16"
              >
                <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
              </svg>
            </span>
          ))}
          {emptyArr.map((_, index) => (
            <span
              key={`empty-${index}`}
              //   onClick={() => handleStarClick(filledStars + index)}
              style={{ color: "gray", cursor: "pointer" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-star"
                viewBox="0 0 16 16"
              >
                <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
              </svg>
            </span>
          ))}
        </div>
      );
    }
  };
  //   const dateCreated = new Date(OrderDetails?.date_create).toISOString().split('T')[0];
  // const hotelimglength = hotelimg.length()
  const hotelImage = async (hotel_id) => {
    debugger;

    try {
      var findImg = {
        etmtoken: etmtoken,
        hotel_id: hotel_id,
      };

      const response = await fetch(base_url + "/get_hotel_info", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + vendorKey,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(findImg),
      });
      if (!response.ok) {
        console.log("http response status : ", response.status);
      } else {
        const data = await response.json()
        if (data.message === "success" && data.result && data.result.images) {
          setHotelImage((prev) => ({
            ...prev,
            [hotel_id]: data.result.images,
          }));

          setCurrentHotelId(hotel_id); // for lightbox
          setPhotoIndex(0); // start with first image
          setIsOpen(true);
        }
      }
    } catch (error) {
      console.error("Error fetching hotel images:", error);
    }
  };

  const handlesumbit =  () =>{
    debugger
    window.location.href = '/'
  }

  //   const checkindate = new Date(OrderDetails?.check_in);
  //   const formattedDatecheckin = checkindate.toLocaleString('en-GB', {
  //     weekday: 'short',
  //     year: 'numeric',
  //     month: 'short',
  //     day: '2-digit',
  //     hour: '2-digit',
  //     minute: '2-digit',
  //     hour12: true
  //   });

  const [isRoomOpen, setIsRoomOpen] = useState(false);
  const [photoIndex1, setPhotoIndex1] = useState(0);
  const [roomImages, setRoomImages] = useState([]);

  const openRoomImages = () => {
    if (
      OrderDetails?.rooms?.length > 0 &&
      OrderDetails.rooms[0].images.length > 0
    ) {
      setRoomImages(OrderDetails.rooms[0].images);
      setPhotoIndex(0);
      setIsRoomOpen(true);
    }
  };

  //     const checkoutdate = new Date(OrderDetails?.check_out);
  //   const formattedDatecheckout = checkoutdate.toLocaleString('en-GB', {
  //     weekday: 'short',
  //     year: 'numeric',
  //     month: 'short',
  //     day: '2-digit',
  //     hour: '2-digit',
  //     minute: '2-digit',
  //     hour12: true
  //   });

  const handleShowFacilities=(amenities_names)=>{
  setAmenities(amenities_names);
  setFacilitiesPopup(true);
}
const handleClose=()=>{
   setAmenities([]);
  setFacilitiesPopup(false);
}

  return (
    <div className="App" dir={lnstr === "ar" ? "rtl" : "ltr"} style={{textAlign:lnstr === "ar" ? "right" : "left" }}>
      <div className="header_section1">
        <Navbar />

        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">
              {t("Order")} {t("Details")}
            </h3>
          </div>
        </div>
      </div>

      <div className="features_section layout_padding">
        <div className="container">
          <div className="row">
            <Col md={1}></Col>
            <Col md={10} className="myforms my-5">
              {/* Main Order Card */}
              <div className="card p-4 shadow" style={{ backgroundColor: "#f8f9fa", border: "1px solid #e0e0e0" }}>
                {/* Header Section */}
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <h4 className="mb-1" style={{ fontWeight: "600" }}>
                      {t("Order")} {t("Details")} {t("No")}: {OrderDetails?.id} 
                      
                    </h4>
                    <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                      {t("PNR Number")}: {OrderDetails?.supplier_book_number || 'N/A'}
                    </p>
                  </div>
                  <div className="text-end">
                    <p className="mb-1" style={{ fontSize: "14px", color: "#666" }}>
                      {t("Date")} {t("Created")}: <strong>{OrderDetails?.date_create ? new Date(OrderDetails.date_create).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' }) : 'N/A'}</strong>
                    </p>
              <p className="badge bg-success text-white  ms-2 px-3 py-2 " style={{ fontSize: "13px",float:"right" }}>
                         {OrderDetails?.status_name}
                      </p>
                  </div>
                </div>
                {/* Hotel Information */}
                <div className="mb-4">
                <div className="card p-3 rounded shadow">
                
                <div className="row mb-4">
                  <h5 className="mb-3 col-md-12" style={{ fontWeight: "600" }}>{t("Hotel")} {t("Details")}</h5>
                  <div className="col-md-6">
                  <div className="col-md-12">
                    <div className="position-relative" style={{ cursor: "pointer" }} onClick={() => hotelImage(OrderDetails?.hotel?.id)}>
                      <img
                        src={OrderDetails?.hotel?.image?.url}
                        alt={OrderDetails?.hotel?.name}
                        className="img-fluid rounded"
                        style={{ width: "100%", height: "150px", objectFit: "cover" }}
                      />
                      <div className="position-absolute" style={{ bottom: "8px", right: "8px", backgroundColor: "rgba(0, 0, 0, 0.7)", color: "white", padding: "4px 8px", fontSize: "11px", borderRadius: "4px" }}>
                        <img src={hotelimg} alt="" width="12" height="10" style={{ filter: "invert(1)" }} className="me-1" />
                        +{OrderDetails?.hotel?.image_qty}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <h5 className="mb-1 mt-1" style={{ color: "#2c5aa0", fontWeight: "600" }}>
                      {OrderDetails?.hotel?.name}
                    </h5>
                    <div className="mb-2">
                      <StarRating rating={OrderDetails?.hotel?.stars} />
                    </div>
                    <p className="text-muted mb-1" style={{ fontSize: "14px" }}>
                      {OrderDetails?.hotel?.address}
                    </p>
                    {/* <button className="btn btn-link text-primary p-0" style={{ fontSize: "14px" }}>Look at the map</button> */}
                  </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card">
                        <table className="table">
  <tbody>

    <tr>
      <td style={{ width: "40%" }}>{t("Check-in")}</td>
      <td>:</td>
      <td className="">
        {OrderDetails?.check_in
          ? `${new Date(OrderDetails.check_in).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} 
             ${new Date(OrderDetails.check_in).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}`
          : "N/A"}
      </td>
    </tr>

    <tr>
      <td>{t("Check-out")}</td>
      <td>:</td>
      <td className="">
        {OrderDetails?.check_out
          ? `${new Date(OrderDetails.check_out).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} 
             ${new Date(OrderDetails.check_out).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}`
          : "N/A"}
      </td>
    </tr>

    <tr>
      {lnstr=="en"?<td>Number of nights</td>:<td>عدد الليالي</td>}
      <td>:</td>
      <td className="">{OrderDetails?.nights_qty || "N/A"}</td>
    </tr>

    <tr>
      {lnstr=="en"?<td>Rooms</td>:<td>الغرف</td>}
      <td>:</td>
      <td className="">{OrderDetails?.rooms?.[0]?.availability || "N/A"}</td>
    </tr>

    <tr>
      {lnstr=="en"?<td>Number of guests</td>:<td>عدد الضيوف</td>}
      <td>:</td>
      <td className="">{OrderDetails?.rooms?.[0]?.adult_qty || "N/A"}</td>
    </tr>

  </tbody>
                        </table>
                        </div>
                  </div>
                </div>


                {/* Booking Details */}
         



                </div>
                </div>
                {/* Room Section */}
               
                <div className="mb-4">
                   <div className="card p-3 rounded shadow">
                  <h5 className="mb-3" style={{ fontWeight: "600" }}>{t("Room")} {t("Details")}</h5>
                  <div className="row align-items-center" style={{ backgroundColor: "white", padding: "15px", borderRadius: "8px" }}>
                    <div className="col-md-1">
                      <div className="text-center" style={{ fontSize: "24px", fontWeight: "600" }}>1x</div>
                    </div>
                    <div className="col-md-2">
                      <div className="position-relative" style={{ cursor: "pointer" }} onClick={openRoomImages}>
                        <img
                          src={OrderDetails?.rooms?.[0]?.images?.[0]?.url || ""}
                          alt="Room"
                          className="img-fluid rounded"
                          style={{ width: "100%", height: "80px", objectFit: "cover" }}
                        />
                        {OrderDetails?.rooms?.[0]?.images?.length > 0 && (
                          <div className="position-absolute" style={{ bottom: "8px", right: "8px", backgroundColor: "rgba(0, 0, 0, 0.7)", color: "white", padding: "4px 8px", fontSize: "10px", borderRadius: "4px" }}>
                            <img src={hotelimg} alt="" width="10" height="8" style={{ filter: "invert(1)" }} className="me-1" />
                            +{OrderDetails?.rooms?.[0]?.images?.length}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <h6 className="mb-1" style={{ fontWeight: "600" }}>{OrderDetails?.rooms?.[0]?.class}</h6>
                      <p className="text-muted mb-2" style={{ fontSize: "13px" }}>{OrderDetails?.rooms?.[0]?.description}</p>
                      <div className="d-flex gap-2 flex-wrap">
                        {/* {OrderDetails?.rooms?.[0]?.amenities?.slice(0, 12).map((amenity, idx) => (
                              <>
                                        
                                        <div style={{display:"inline-block",borderRadius:"5px",margin:"5px",marginTop:"0px",background:"#666666",height:"35px",width:"35px", color: "#e3e4e9",
    position: "relative"}} 
    title={amenity?.name}
   
    >
                                          <img src={"https://stage-hotels.etm-system.ru/img/hotel-icons/"+amenity.icon+".svg"} style={{height:"100%",width:"100%"}} alt={amenity?.name} />
                                        </div>
                                        </>
                          
                        ))}
                        {OrderDetails?.rooms?.[0]?.amenities?.length > 12 && (
                            <>
                                        <div style={{display:"inline-block",borderRadius:"5px",marginTop:"0px",background:"#a1a1a1ff",height:"35px",width:"35px", color: "#e3e4e9",
    position: "relative",cursor:'pointer'}} onClick={()=>{handleShowFacilities(roomobj.amenities)}}>
                                         <p style={{fontSize: "2.3rem",
    margin: "0px",
    textAlign: "center"}}>...</p>
                                        </div>
                                        </>
                        )} */}
                          {
                                      OrderDetails?.rooms?.[0]?.amenities.map((icon,icon_index)=>{
                                        
                                        if(icon_index< 14 && isNaN(parseInt(icon.icon))){
                                        return(
                                        <>
                                        {/* <div id={"hover_"+icon.icon}></div> */}
                                        <div style={{display:"inline-block",borderRadius:"5px",margin:"5px",marginTop:"0px",background:"#666666",height:"35px",width:"35px", color: "#e3e4e9",
    position: "relative"}} 
    title={icon.name}
    // onMouseLeave={(e)=>handleStopMessagePopup(e,icon.icon)} onMouseEnter={(e)=>{handleShowMessagePopup(e,icon.icon)}}
    >
                                          <img src={"https://stage-hotels.etm-system.ru/img/hotel-icons/"+icon.icon+".svg"} style={{height:"100%",width:"100%"}} alt="" />
                                        </div>
                                        </>
                                        )
                                        }
                                        if(OrderDetails?.rooms?.[0]?.amenities.length-1===icon_index){
                                          return(
                                              <>
                                        <div style={{display:"inline-block",borderRadius:"5px",marginTop:"0px",background:"#a1a1a1ff",height:"35px",width:"35px", color: "#e3e4e9",
    position: "relative",cursor:'pointer'}} onClick={()=>{handleShowFacilities(OrderDetails?.rooms?.[0]?.amenities)}}>
                                         <p style={{fontSize: "2.3rem",
    margin: "0px",
    textAlign: "center"}}>...</p>
                                        </div>
                                        </>
                                          )
                                        }
                                      }
                                    )
                                    
                                       
                                   
                                    }
                      </div>
                    </div>
                  </div>
                </div>
               </div>

<div className="row">
                {/* Guests Section */}
                <div className="mb-4 col-md-6">
                    <div className="card p-3 rounded shadow">
                  <h5 className="mb-3" style={{ fontWeight: "600" }}>{t("Guests")}</h5>
                  <div className="d-flex justify-content-start  flex-column">
                    
{segmentsData?.rooms?.[0]?.guests?.map((guest, idx) => (
  <span key={idx} className="d-flex align-items-center">
    <i className="fas fa-user me-1"></i> 
    <span className={`${lnstr=="en"?"ml-3":"mr-3"}`}>{guest?.firstname} {guest?.lastname} - {guest?.type}</span>
  </span>
))}

                    
                  </div>
                  </div>
                </div>

                {/* Buyer Info */}
                <div className="mb-4 col-md-6">
 <div className="card p-3 rounded shadow">
                  {lnstr=="en"?<h5 className="mb-3" style={{ fontWeight: "600" }}>Buyer billing info</h5>:<h5 className="mb-3" style={{ fontWeight: "600" }}>بيانات الدفع</h5>}

                  <div className="row ">
                    
                   {OrderDetails?.emails?.map((email, index) => (
                    <>
                    <div className="col-lg-4">
                   { index==0? t("Email(s)"):""}
                    </div>
  <div key={index} className="col-lg-8">
    <p className="mb-1" style={{ fontSize: "14px" }}>
     : {email?.value}
    </p>
  </div>
  </>
))} 
                   {OrderDetails?.phones?.map((phone, index) => ( 
                    <>
                     <div className="col-lg-4 ">
                   { index==0? t("Phone(s)"):""}
                    </div>
                     <div key={index}className="col-lg-8">
                      <p className="mb-1" style={{ fontSize: "14px" }}>
                        : {phone?.value}
                      </p>
                      {/* <button className="btn btn-link text-primary p-0" style={{ fontSize: "14px" }}>Edit</button> */}
                    </div>
                    </>))}
                  </div>
                </div>
                </div>
                </div>
              </div>

          

              {/* Go Home Button */}
              <div className="text-center mt-4">
                <button className="btn btn-primary px-4" onClick={handlesumbit}>
                  {t("Go To Home")}
                </button>
              </div>

              {/* <div
                className="card p-3 shadow mt-3"
                style={{
                  boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.3)",
                  Width: "100%",
                }}
              >
                <div className="">
                  <div className="card p-2 shadow mt-0">
                    <table className="table table-bordered ">
                      <thead style={{ backgroundColor: "#f4f6fb" }}>
                        <tr>
                          <td>{t("Room")}</td>
                          <td>{t("Guests")}</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td></td>
                          <td>
                            {" "}
                            <div className="d-flex">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                class="bi bi-person-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                              </svg>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div> */}
              
            </Col>
            <Col md={1}></Col>
          </div>
        </div>
      </div>

      {/* Lightbox for hotel images */}
      {isOpen && hotelimage[currentHotelId]?.length > 0 && (
        <>
          <Lightbox
            mainSrc={hotelimage[currentHotelId][photoIndex].url}
            nextSrc={hotelimage[currentHotelId][(photoIndex + 1) % hotelimage[currentHotelId].length].url}
            prevSrc={hotelimage[currentHotelId][(photoIndex + hotelimage[currentHotelId].length - 1) % hotelimage[currentHotelId].length].url}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() => setPhotoIndex((photoIndex + hotelimage[currentHotelId].length - 1) % hotelimage[currentHotelId].length)}
            onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % hotelimage[currentHotelId].length)}
            imageTitle={`${photoIndex + 1} / ${hotelimage[currentHotelId].length}`}
            wrapperClassName="custom-lightbox"
          />
          <div style={{ position: "fixed", bottom: 10, left: 0, right: 0, padding: "10px 20px", display: "flex", overflowX: "auto", backgroundColor: "rgba(0, 0, 0, 0.3)", zIndex: 1600, gap: "10px" }}>
            {hotelimage[currentHotelId]?.map((img, idx) => (
              <img
                key={idx}
                src={img.url}
                alt={`Thumb ${idx}`}
                onClick={() => setPhotoIndex(idx)}
                style={{ width: "80px", height: "60px", objectFit: "cover", border: idx === photoIndex ? "3px solid #00bfff" : "2px solid #666", opacity: idx === photoIndex ? 1 : 0.6, cursor: "pointer", borderRadius: "4px", transition: "all 0.2s ease-in-out" }}
              />
            ))}
          </div>
        </>
      )}

      {(facilitiesPopup && amenities.length>0) &&
  
        <div className="modal">
          <div
            className="modal-content"
            style={{ height: "auto", width: "700px",textAlign:"start" }}
          >
            <h2>
              <span>
                {t("Room facilities")}
              </span>
            </h2>
            <div type="button" className={`position-absolute`} style ={{fontSize:"1.5rem",fontWeight:"400",top:"10px",right:lnstr==="en"&&"20px",left:lnstr==="ar"&&"20px",cursor:"pointer"}} onClick={handleClose} >
              &times;
            </div>
            {/* <div style={{ height: "50px" }}></div> */}
            <div>
            <ul className="mx-5">
           {
            amenities.map((icon)=>{
              if(isNaN(parseInt(icon.icon)))
              return(
              <li className="text-start">{t(icon.name)}</li>
              )

           })
              
           }
           </ul>
           
            </div>
          </div>
        </div>
   
}

      {/* Lightbox for room images */}
      {isRoomOpen && roomImages.length > 0 && (
        <>
          <Lightbox
            mainSrc={roomImages[photoIndex].url}
            nextSrc={roomImages[(photoIndex + 1) % roomImages.length].url}
            prevSrc={roomImages[(photoIndex + roomImages.length - 1) % roomImages.length].url}
            onCloseRequest={() => setIsRoomOpen(false)}
            onMovePrevRequest={() => setPhotoIndex((photoIndex + roomImages.length - 1) % roomImages.length)}
            onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % roomImages.length)}
            imageTitle={`${photoIndex + 1} / ${roomImages.length}`}
            wrapperClassName="custom-lightbox"
          />
          <div style={{ position: "fixed", bottom: 10, left: 0, right: 0, padding: "10px 20px", display: "flex", overflowX: "auto", backgroundColor: "rgba(0, 0, 0, 0.3)", zIndex: 1600, gap: "10px" }}>
            {roomImages.map((img, idx) => (
              <img
                key={idx}
                src={img.url}
                alt={`Room Thumb ${idx + 1}`}
                onClick={() => setPhotoIndex(idx)}
                style={{ width: "80px", height: "60px", objectFit: "cover", border: idx === photoIndex ? "3px solid #00bfff" : "2px solid #666", opacity: idx === photoIndex ? 1 : 0.6, cursor: "pointer", borderRadius: "4px", transition: "all 0.2s ease-in-out" }}
              />
            ))}
          </div>
        </>
      )}

      <Footer />
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </div>
  );
}

export default HotelOrderStatus;
